import React from "react";
import { CatalogContext } from "../Translator/withTranslation";
import { RenderContext } from "../Context/Ssr";
import { LocaleContext } from "../Context/Locale";
import { CurrencyContext } from "../Context/Currency";
import { ResponsiveFooterInner } from "./ResponsiveFooterInner";

class ResponsiveFooterComponent extends React.Component {
    constructor(props, ctx) {
        super(props);
    }
    render() {
        return (
            <ResponsiveFooterInner />
        );
    }
}

export const ResponsiveFooter = (initialProps, context) => {
    return (
        <LocaleContext.Provider value={initialProps.locale}>
            <CatalogContext.Provider value={initialProps.catalog}>
            <RenderContext.Provider value={context}>
                <CurrencyContext.Provider value={initialProps.currency}>
                    <ResponsiveFooterInner { ...initialProps} />
                </CurrencyContext.Provider>
            </RenderContext.Provider>
            </CatalogContext.Provider>
        </LocaleContext.Provider>
    );
}